import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  previewBlock: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
  },
  defaultProfile: {
    width: '65px',
    height: '65px',
    display: 'inline-block',
  },
  profileDetails: {
    display: 'inline-block',
    '& div p:nth-of-type(1)': {
      display: 'block',
    },
    '& div p:nth-of-type(2)::after': {
      content: "' | '",
    },
    padding: '7px',
  },
  contactInformation: {
    display: 'block',
  },
  profileText: {
    display: 'inline-block',
    color: 'grey',
    padding: '3px',
  },
  displayName: {
    color: 'black',
    fontSize: '20px',
  },
}));

export default useStyles;
